module.exports = __webpack_public_path__ + "static/media/Train-Card.d37e2b22.jpeg";